import { ALL_LANGUAGES } from '../../constants';
import getRouteTrans from './english';

const routeTrans = {
    [ALL_LANGUAGES.english.value]: getRouteTrans
};

export default routeTrans;
